import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { ToggleButton } from './ThemeToggleButton.styles';

const ThemeToggleButton = ({ theme, toggleTheme }) => {
  return (
    <ToggleButton onClick={toggleTheme}>
      {theme === 'light' ? <Moon size={20} /> : <Sun size={20} />}
    </ToggleButton>
  );
};

export default ThemeToggleButton;